"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SignInDialog = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _react2 = _interopRequireDefault(require("react"));

var SignInDialog = function SignInDialog(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Dialog, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    hidden: false,
    modalProps: {
      isBlocking: true
    },
    dialogContentProps: (0, _objectSpread2.default)({
      type: _react.DialogType.normal
    }, props.dialogContentProps),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DialogFooter, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.PrimaryButton, {
        onClick: props.login,
        children: props.loginText || props.t('SignIn')
      })
    })
  }));
};

exports.SignInDialog = SignInDialog;